export default {
    colors: {
        background: "rgba(0,0,0,0.75)",
        boxBackground: "#000",
        textColor: "#fff",
        linkColor: "#8ab0e5"
    }
  };